function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m509.256 191.272c-1.907-2.048-4.655-3.104-7.453-3.104h-30.712c-12.402-51.322-41.402-97.831-82.36-131.752-43.899-36.353-99.51-56.386-156.604-56.416-.94 0-1.889.201-2.69.694-2.161 1.331-2.936 3.881-2.119 6.061l27.416 73.167c.731 1.953 2.597 3.246 4.682 3.246 64.833 0 121.64 43.53 139.152 105h-26.37c-2.799 0-5.546 1.056-7.453 3.104-3.594 3.86-3.576 9.518-.427 13.297l65 78c1.9 2.28 4.715 3.599 7.683 3.599s5.782-1.318 7.683-3.599l65-78c3.148-3.779 3.165-9.437-.428-13.297z",
  fill: "#050358"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 227,
  cy: 125,
  fill: "#4292ff",
  r: 110
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m337 125c0-60.751-49.249-110-110-110v220c60.751 0 110-49.249 110-110z",
  fill: "#4292ff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m227 250c-68.925 0-125-56.075-125-125s56.075-125 125-125 125 56.075 125 125-56.075 125-125 125zm0-220c-52.383 0-95 42.617-95 95s42.617 95 95 95 95-42.617 95-95-42.617-95-95-95z",
  fill: "#4292ff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m322 125c0 52.383-42.617 95-95 95v30c68.925 0 125-56.075 125-125s-56.075-125-125-125v30c52.383 0 95 42.617 95 95z",
  fill: "#4292ff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m267 150c0-22.056-17.944-40-40-40-5.514 0-10-4.486-10-10s4.486-10 10-10c4.736 0 8.856 3.358 9.796 7.985 1.648 8.118 9.571 13.363 17.686 11.715 8.118-1.649 13.363-9.567 11.715-17.686-2.721-13.396-12.075-24.136-24.197-29.072v-2.942c0-8.284-6.716-15-15-15s-15 6.716-15 15v2.929c-14.643 5.947-25 20.318-25 37.071 0 22.056 17.944 40 40 40 5.514 0 10 4.486 10 10s-4.486 10-10 10c-4.736 0-8.856-3.358-9.796-7.985-1.648-8.118-9.565-13.361-17.686-11.715-8.119 1.649-13.363 9.567-11.715 17.686 2.721 13.396 12.075 24.137 24.196 29.073v2.941c0 8.284 6.716 15 15 15s15-6.716 15-15v-2.929c14.644-5.947 25.001-20.319 25.001-37.071z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m227 110v30c5.514 0 10 4.486 10 10s-4.486 10-10 10v45c8.284 0 15-6.716 15-15v-2.929c14.643-5.947 25-20.318 25-37.071 0-22.056-17.944-40-40-40z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m236.796 97.985c1.648 8.118 9.571 13.363 17.686 11.715 8.118-1.649 13.363-9.567 11.715-17.686-2.721-13.396-12.075-24.136-24.197-29.072v-2.942c0-8.284-6.716-15-15-15v45c4.736 0 8.856 3.358 9.796 7.985z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m505.667 350.946c-11.087-15.834-32.911-19.682-48.745-8.595l-107.294 75.128c-4.203 2.943-9.209 4.521-14.339 4.521h-79.289v70h85.594c15.392 0 30.41-4.735 43.018-13.564l112.459-78.745c15.835-11.087 19.684-32.911 8.596-48.745z",
  fill: "#abb8c3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m349.628 417.479c-4.203 2.943-9.209 4.521-14.339 4.521l-79.289-6.148v36.148h81c35.841 0 65-29.159 65-65 0-2.021-.106-4.017-.287-5.991z",
  fill: "#abb8c3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m505.667 350.946c-11.087-15.834-32.911-19.682-48.745-8.595l-90.237 63.185c3.364-5.377 5.315-11.727 5.315-18.536 0-19.33-15.67-35-35-35h-85l-9.784-7.338c-19.485-14.614-43.629-22.662-67.986-22.662-20.533 0-40.691 5.583-58.297 16.147 0 0-16.681 10.009-26.652 15.991-4.518 2.711-7.281 7.593-7.281 12.862v110c0 8.284 6.716 15 15 15h244.594c15.392 0 30.41-4.735 43.018-13.564l112.459-78.745c15.835-11.087 19.684-32.911 8.596-48.745z",
  fill: "#abb8c3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m256 492h85.594c15.392 0 30.41-4.735 43.018-13.564l112.459-78.745c15.834-11.087 19.682-32.911 8.595-48.745-11.087-15.834-32.911-19.682-48.745-8.595l-90.237 63.185c3.365-5.377 5.316-11.727 5.316-18.536 0-19.33-15.67-35-35-35h-81z",
  fill: "#abb8c3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m401.713 381.009-35.028 24.527c-.217.347-.434.695-.663 1.033-6.289 9.31-16.941 15.431-29.022 15.431h-105c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h105c35.841 0 65-29.159 65-65 0-2.021-.106-4.017-.287-5.991z",
  fill: "#abb8c3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m97 512h-82c-8.284 0-15-6.716-15-15v-170c0-8.284 6.716-15 15-15h82c8.284 0 15 6.716 15 15v170c0 8.284-6.716 15-15 15z",
  fill: "#abb8c3"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m401.713 381.009-35.028 24.527c-.217.347-.434.695-.663 1.033-6.289 9.31-16.941 15.431-29.022 15.431h-81v30h81c35.841 0 65-29.159 65-65 0-2.021-.106-4.017-.287-5.991z",
  fill: "#abb8c3"
});

var SvgPortabilityConsumoCredit = function SvgPortabilityConsumoCredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 76.336,
    viewBox: "0 0 512 512",
    width: 76.336,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPortabilityConsumoCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/portabilityConsumoCredit.994ac1dd.svg";
export { ForwardRef as ReactComponent };